module.exports = __webpack_public_path__ + "img/mtn.7aeabab0.png";